import React from "react";
import { Route } from "react-router";
import { appBasePath } from "../../../config/paths";
import Dashboard from "./Dashboard";
import SideMenu from "./SideMenu";
import StockBrowser from "./StockBrowser";
import { AppContainer } from "./styles";
import { deriveCurrentOption } from "./utils";

function App({ location }) {
  let currentOption = deriveCurrentOption(location);
  return (
    <AppContainer>
      <SideMenu currentOption={currentOption} />
      <Route path={appBasePath+"app/dashboard"} component={Dashboard}/>
      <Route path={appBasePath+"app/browser"} component={StockBrowser}/>
    </AppContainer>
  );
}
export default App;
